export default __webpack_public_path__ + "static/media/poll_icon_white.5b7f1fd1.svg";